import { type MetricField, type OrganicStatsResponseTimeEntry } from "../../gql-generated/types";

export const extractValueByIndex = (
    entryList: readonly OrganicStatsResponseTimeEntry[],
    index: number,
    metricField: MetricField,
): number => {
    const element = entryList[index]?.statsList.find(({ field }) => field?.fieldName === metricField);

    return Number.parseInt(element?.statsList[0]?.value ?? "");
};
